export const getSuggestiveFieldTestId = (id: string) => {
    return `${id}-suggestive-input`;
};

export const getMultiSuggestiveFieldTestId = (id: string) => {
    return `${id}-multi-suggestive-input`;
};

export const getEmptyResultsTextTestId = (id: string) => {
    return `${id}-empty-results-text`;
};
